// 获取门票随机减少的数量
const baseTickets = 3999; // 每小时初始门票数量
const totalTickets = 30000; // 总报名人数
const baseBigTickets = 26000; // 无总数限制，基数26000

function getRandomReduction() {
   const probabilities = {
      1: 16.7,
      2: 50.0,
      3: 33.3
    };
    const random = Math.random() * 100;
    let accumulated = 0;
    
    for (const [amount, probability] of Object.entries(probabilities)) {
      accumulated += probability;
      
      if (random <= accumulated) {
        return parseInt(amount);
      }
    }
    return 2;
}

// 计算当前小时已经过去的秒数
function getCurrentSeconds() {
  const now = new Date();
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();
  return minutes * 60 + seconds;
}

// 计算距离下一个整点的毫秒数 （下一整点，门票需要重新初始化3999）
function getTimeToNextHour() {
  const now = new Date();
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();
  const milliseconds = now.getMilliseconds();
  
  // 计算距离下一个整点的毫秒数
  const minutesToNextHour = 59 - minutes;
  const secondsToNextHour = 60 - seconds;
  const totalMilliseconds = (minutesToNextHour * 60 + secondsToNextHour) * 1000 - milliseconds;
  
  return totalMilliseconds;
}


// 初始化当前门票 （每2秒执行一次事件，每次事件随机减少1-3张门票）
function initCurrentTickets() {
  // 计算当前小时已经过去的秒数
  const secondsPassed = getCurrentSeconds();
  
  // 计算已经发生的减少事件次数（每2秒一次）
  const eventsPassed = Math.floor(secondsPassed / 2);
  
  // 计算已经减少的门票总数
  let totalReduced = 0;
  for (let i = 0; i < eventsPassed; i++) {
    totalReduced += getRandomReduction();
  }
  
  // 设置当前门票数量
  const currentTickets = baseTickets - totalReduced;

  return {
    totalReduced,
    currentTickets,
  }
}



/**
 * 模版一,模版五（倒计时） 
 * 剩余门票 = 3999基数 - 递减门票总量
 * 已报名人数 =  26000基数 + 递减门票总量
 */



/**
 * 模版六（快速领票） 
 * 剩余门票 = 3999基数 - 递减门票总量
 * 已报名人数 =  30000基数 - 当前剩余门票数量
 */


export {
  getRandomReduction,
  getCurrentSeconds,
  getTimeToNextHour,
  initCurrentTickets,
}